(function inbentaFaq() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'inbenta-faq';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }
  const inbentaApi = GlobalSite.checkDependency('GlobalSite.inbentaApi');
  const searchEngineUi = GlobalSite.checkDependency('GlobalSite.searchEngineUi');
  const answerBlockUi = GlobalSite.checkDependency('GlobalSite.answerBlockUi');
  const categoriesBlockUi = GlobalSite.checkDependency('GlobalSite.categoriesBlockUi');

  $(async () => {
    const $searchInput = $('.inbenta-form-input .search');
    const $submitInput = $('.inbenta-form-submit .submit');
    const $deleteButton = $('.inbenta-form-input .delete-btn');
    const $autocomplete = $('.inbenta-autocomplete');

    const $inbentaHowModal = $('.modal-form-search-content');
    const $catLevelOne = $('#inbenta-category-level1');
    const $modalShowButton = $('button.search-modal');

    const inbentaAuth = await inbentaApi.auth();
    const inbentaHowModal = await inbentaApi.getModalHtml('faq');

    const categoriesUi = await categoriesBlockUi($catLevelOne, 0);

    function inbentaHowModalRender() {
      if(inbentaHowModal?.results) {
        $inbentaHowModal.append(inbentaHowModal?.results[0]?.value?.html);
      }else {
        $modalShowButton.hide();
      }
    }

    inbentaHowModalRender();
    inbentaAuth &&
      searchEngineUi([$searchInput, $submitInput, $deleteButton, $autocomplete], 'faq');

    if (!categoriesUi?.isInPath) {
      const popularAnswers = await inbentaApi.getPopular('faq');
      inbentaAuth && answerBlockUi('popular', popularAnswers?.results, 'faq');
    }
  });
})();
